<template>
  <div>
    <p class="text-queue-step">
      {{
        $t("IdentityQueueStepCounter.p.stepCount", {
          currentStep,
          totalSteps,
        })
      }}
    </p>
  </div>
</template>

<script setup>
import { computed, watch } from "vue"; //! watch is not used
import { useRoute } from "vue-router";
import { whenever } from "@vueuse/core"; //! Not used
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

const route = useRoute(); //! This is not used
const identityQueueStore = useIdentityQueueStore();
const currentStep = computed(() => identityQueueStore.queueCounter);
const totalSteps = computed(() => identityQueueStore.totalSteps);
</script>

<style lang="scss" scoped></style>
